<template>
  <div class="h-100">
    <iframe
      v-if="url"
      :src="url"
      @load="doseSpotLoaded"
      frameBorder="0"
      class="h-100 w-100"
    ></iframe>
    <div
      v-else-if="this.client && !this.client.doseSpotId"
      class="p-4 h-100 d-flex flex-column justify-content-center align-items-center"
    >
      <div>
        <div
          v-if="missingFields.length"
          class="d-flex flex-column align-items-center"
        >
          <span>
            Please complete the following fields to enable E-Prescribe for this
            patient:
          </span>
          <strong>
            {{ missingFieldsDisplay }}
          </strong>
        </div>
        <div v-else class="d-flex flex-column align-items-start">
          <span>
            Please click the button below to synchronize the patient with the
            E-Prescribe system
          </span>
          <b-button
            :disabled="missingFields.length > 0"
            @click="synchronize"
            variant="primary"
            class="align-self-center smaller-button button-custom-green mt-3"
          >
            <i class="fa fa-refresh mr-2" aria-hidden="true"></i>
            Synchronize
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import patientServer from "../../server/patient";
import doseSpotServer from "../../server/doseSpot";
export default {
  props: ["clientId"],
  name: "PatientDoseSpot",
  data() {
    return {
      client: null,
      url: "",
      requiredFields: [
        { key: "firstName", label: "First name" },
        { key: "lastName", label: "Last name" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Mobile Phone" },
        { key: "dateOfBirth", label: "Date of birth" },
        { key: "gender", label: "Legal Sex" },
        { key: "addressLine1", label: "Address line 1" },
        { key: "city", label: "City" },
        { key: "state", label: "State" },
        { key: "zipcode", label: "Zipcode" }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions("layout", ["showError", "show", "hide"]),
    async fetchData() {
      this.client = await patientServer.get(this.clientId);
      if (this.client.doseSpotId) {
        this.url = await doseSpotServer.getUrlData(this.clientId);
        this.show();
      }
    },
    async synchronize() {
      await patientServer.syncDoseSpot(this.clientId);
      this.client = await patientServer.get(this.clientId);
      if (!this.client.doseSpotId) {
        this.showError({
          message:
            "An error occurred during the synchronization. Please try again later or contact support if you need help."
        });
      } else {
        this.url = await doseSpotServer.getUrlData(this.clientId);
        this.show();
      }
    },
    doseSpotLoaded() {
      this.hide();
    }
  },
  computed: {
    missingFields() {
      if (!this.client) return [];
      return this.requiredFields.reduce((acc, field) => {
        if (!this.client[field.key]) {
          acc = [...acc, field.label];
        }
        return acc;
      }, []);
    },
    missingFieldsDisplay() {
      return this.missingFields.join(", ");
    }
  },
  watch: {
    "listeners.fetchClient": function(newValue, oldValue) {
      if (newValue[this.clientId] != oldValue[this.clientId]) {
        this.fetchData();
      }
    }
  }
};
</script>

<style></style>
